@if (label()) {
  <label class="form-label">{{ label() }}</label>
}
<div class="d-flex flex-wrap">
  @for (digit of digits(); track $index) {
    <input
      #inputs
      (keypress)="onKeyPress($event)"
      (input)="onInput($event, $index)"
      (paste)="onPaste($event)"
      [value]="digit"
      type="text"
      id="mfa-{{ $index }}"
      name="mfa-{{ $index }}"
      class="form-control"
      style="width: 35px; margin-right: var(--space-x-5px)"
      autocomplete="off"
      maxlength="1"
      inputmode="numeric"
    />
  }
</div>
